import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-242f849e")

_pushScopeId("data-v-242f849e")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "nav flex" }
const _hoisted_3 = { class: "flex top-button-group alignC" }
const _hoisted_4 = { class: "flex alignC mar-r-18 mar-b-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "结算时间", -1)
const _hoisted_6 = { class: "flex alignC mar-b-10" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "服务类型", -1)
const _hoisted_8 = { class: "flex alignC mar-b-10" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "是否满意", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "意见/建议", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "使用状况", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "回访结果", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("返修工单 ")
const _hoisted_14 = { class: "flex alignC cascader mar-b-10" }
const _hoisted_15 = {
  class: "flex button-group",
  style: {"justify-content":"center"}
}
const _hoisted_16 = { class: "c-ff" }
const _hoisted_17 = { class: "flex flexR mar-t-22" }
const _hoisted_18 = { class: "flex flexC" }
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
const _hoisted_22 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderStatusNav, (item) => {
        return (_openBlock(), _createBlock("p", {
          class: ["mar-r-20", {
                    'nav-range c-red': item.id == _ctx.navIndex,
                }],
          key: item.id,
          onClick: ($event: any) => (_ctx.pageChangeClick(item))
        }, _toDisplayString(item.name), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.screenParameter.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'start_date')))
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"160px"},
          modelValue: _ctx.screenParameter.basicset_id,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.basicset_id = $event)),
          placeholder: "选择预约服务分类",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.project, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.basicset_name,
                value: item.basicset_id,
                key: item.basicset_id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _withDirectives(_createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.is_satisfied,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.is_satisfied = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "满意",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "不满意",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _hoisted_10,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.suggest_type,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.suggest_type = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.visitType, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.basicset_name,
                value: item.basicset_id,
                key: item.basicset_id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _hoisted_11,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.usage,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.usage = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "正常",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "异常",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _hoisted_12,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.back_type,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.back_type = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.returnVisit, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.basicset_name,
                value: item.basicset_id,
                key: item.basicset_id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ], 512), [
        [_vShow, _ctx.screenParameter.client_review_status == 2]
      ]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.screenParameter.status,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.status = $event)),
        class: "mar-r-8 mar-b-10",
        "true-label": "1",
        "false-label": "2",
        onChange: _ctx.screenChange
      }, {
        default: _withId(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.screenParameter.search,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenParameter.search = $event)),
          placeholder: "车牌/工单号/送修人/手机",
          "suffix-icon": "el-icon-search",
          onChange: _ctx.screenChange
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "关联单据",
          align: "center",
          "min-width": "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "text-center c-red purchaes_number",
              onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row))
            }, _toDisplayString(scope.row.ordersn), 9, ["onClick"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_el_button, {
                class: "bg-red",
                onClick: ($event: any) => (_ctx.columnChange(scope.row))
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.buttonText[_ctx.navIndex]), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total[_ctx.navIndex]
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.buttonText[_ctx.navIndex],
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: ""
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            ref: "formRef",
            "label-width": "150px"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, { label: "车牌号码" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.car_code,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.car_code = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "是否满意" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"278px"},
                    modelValue: _ctx.form.is_satisfied,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.is_satisfied = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_option, {
                        label: "满意",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "不满意",
                        value: 2
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "意见/建议" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"278px"},
                    modelValue: _ctx.form.suggest_type,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.suggest_type = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.visitType, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.basicset_name,
                          value: item.basicset_id,
                          key: item.basicset_id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "其他意见" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"350px"},
                    type: "textarea",
                    rows: 2,
                    modelValue: _ctx.form.suggest,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.suggest = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "使用状况" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"278px"},
                    modelValue: _ctx.form.usage,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.usage = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_option, {
                        label: "正常",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "异常",
                        value: 2
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "异常描述" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"350px"},
                    type: "textarea",
                    rows: 2,
                    modelValue: _ctx.form.abnormal,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.abnormal = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "回访结果" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"278px"},
                    modelValue: _ctx.form.back_type,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.back_type = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.returnVisit, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.basicset_name,
                          value: item.basicset_id,
                          key: item.basicset_id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "备注" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"278px"},
                    modelValue: _ctx.form.desc,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.desc = $event)),
                    type: "textarea",
                    rows: 2
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "工单详情",
      modelValue: _ctx.dialogOrderVisible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dialogOrderVisible = $event)),
      onClosed: _ctx.handleClose,
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_22, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.orderDetail.order_offer_project.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.orderDetail.order_offer_project,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.order_offer_mountings.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _ctx.orderDetail.order_offer_mountings,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 2),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.mountings_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 2,
              data: _ctx.orderDetail.mountings_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 3),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.else_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 3,
              data: _ctx.orderDetail.else_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 4),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.settlement.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 4,
              data: _ctx.orderDetail.settlement,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ]))
})